import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useSelector, useDispatch } from "react-redux";
import InputGroup from "react-bootstrap/InputGroup";
import "../../../index.css";
import {
  setSelectedNVR,
  deleteNVR,
  updateNVRQuantity2,
  updateComparisonData,
  upsertLinkedLaborItem,
  deleteLinkedLaborItems,
} from "../../../app/features/counter/counterSlice";

// Universal Data importing from fetchData folder
import { CategoryCsvData } from "../../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../../fetchData/ProductOptionsCsvData.js";
import { CloseFullscreen, NordicWalking } from "@mui/icons-material";
import WarningComponent from "../WarningComponent.js";

function Nvr() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false); // First Modal State
  const [dropDownData, setDropDownData] = useState([]);
  const [dataforProduct, setdataForProduct] = useState([]); // when you click on modal, data stored
  const [finalNewState, setFinalNewState] = useState({}); // product information stored
  const [finalNewState2, setFinalNewState2] = useState({}); // when you click on modal, dropdown store here
  const [basePrice, setBasePrice] = useState(0);
  const [unitCostInput, setUnitCostInput] = useState("");
  const [allDropDownPrice, setAllDropDownPrice] = useState(0); // 1+2+3...
  const [unitPrice, setUnitPrice] = useState(0);
  const [priceList, setPriceList] = useState(0);
  const [updatePrice, setUpdatePrice] = useState(0);
  const [count, setCount] = useState(1);
  //Fetch CSV Data Starts Here
  const { categoryCSVQuery } = CategoryCsvData();
  const { productCSVQuery } = ProductCsvData();
  const { productOptionCSVQuery } = ProductOptionsCsvData();
  const [editing, setEditing] = useState("add");
  const [totalLicenses, setTotalLicenses] = useState(0);
  const [totalDrops, setTotalDrops] = useState(0);
  const [showWarningComponent, setShowWarningComponent] = useState(false);

  // Redux Data Used Here
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer); // Dealer Accesss
  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const selectedCameraQuantity = useSelector(
    (state) => state.counter1.selectedCameraQuantity
  );

  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);

  const selectedNvrDetails = useSelector((state) => state.counter1.selectedNVR); // NVR Table Data

  const totalCamerasRequired = useSelector(
    (state) => state.counter1.totalCamera
  ); // Access Camera Here
  // console.log("selectedNvrDetails", selectedNvrDetails);
  const filteredNvr2 = [];
  selectedNvrDetails.map((selectedItem) => {
    // console.log("selectedItem", selectedItem);
    filteredNvr2.push({
      uniqueID: selectedItem.uniqueID,
      option_cameras_selected: totalCamerasRequired,
      unitPrice: selectedItem.unitPrice,
      option: selectedItem.num_options,
      category: selectedItem.categories,
      extra_field_5: selectedItem.extra_field_5,
      Product_Name: selectedItem.Product_Name || selectedItem.Name,
      Product_Description: selectedItem.Name,
      Product_Quantity: selectedItem.Product_Quantity,
      Product_Base_Price: selectedItem.Product_Base_Price,
      Product_Final_Price: selectedItem.Product_Final_Price,
      option1_name: "CPU",
      option1_value: selectedItem.CPU,
      option1_price: selectedItem.CPU_price,
      option2_name: "RAM",
      option2_value: selectedItem.RAM,
      option2_price: selectedItem.RAM_price,
      option3_name: "M2 Drive (OS Drive)",
      option3_value: selectedItem["M2 Drive (OS Drive)"],
      option3_price: selectedItem["M2 Drive (OS Drive)_price"],
      option4_name: "Number of IP Licenses",
      option4_value: selectedItem["Number of IP Licenses"],
      option4_price: selectedItem["Number of IP Licenses_price"],
      option5_name: "Hard Drive Size",
      option5_value: selectedItem["Hard Drive Size"],
      option5_price: selectedItem["Hard Drive Size_price"],
      option6_name: "Operating System",
      option6_value: selectedItem["Operating System"],
      option6_price: selectedItem["Operating System_price"],
      thumbnail: selectedItem.thumbnail,
      image1: selectedItem.image1,
      image2: selectedItem.image2,
      image3: selectedItem.image3,
    });
  });

  const tableData = filteredNvr2;
  const dispatch = useDispatch();

  const getItemSku = (item) =>
    String(item?.Product_Name || item?.id || item?.sku || item?.Name || "").trim();

  const isAutoServerNvr = (item) => {
    const sku = getItemSku(item).toUpperCase();
    const nameText = String(item?.Name || item?.name || item?.Product_Description || "").toUpperCase();

    return (
      sku.includes("MICRONVR") ||
      sku.includes("PLATINUMNVR") ||
      nameText.includes("MICRONVR") ||
      nameText.includes("PLATINUMNVR")
    );
  };

  const getAutoServiceFlag = (item) => {
    const explicitFlag = String(item?.extra_field_5 || item?.auto_service || "")
      .trim()
      .toUpperCase();

    if (explicitFlag === "AUTO_SVC_SERVER") return "AUTO_SVC_SERVER";

    // Backward-compatible fallback for existing CSV rows while extra_field_5 is being updated.
    if (isAutoServerNvr(item)) return "AUTO_SVC_SERVER";

    return explicitFlag;
  };

  const findServiceProduct = (serviceSku) =>
    (productCSVQuery || []).find(
      (product) => String(product.id || "").trim().toUpperCase() === serviceSku.toUpperCase()
    );

  const buildLinkedServiceLaborItem = (serviceSku, parentItem, automationType) => {
    const serviceProduct = findServiceProduct(serviceSku);
    const quantity = Number(parentItem?.Product_Quantity || parentItem?.quantity || 1);
    const unitPrice = Number(
      areYouDealer === "Dealer Selected"
        ? serviceProduct?.price_2 || serviceProduct?.price || 0
        : serviceProduct?.price || serviceProduct?.price_2 || 0
    );

    return {
      id: serviceSku,
      Product_Name: serviceSku,
      name: serviceProduct?.name || serviceProduct?.description || serviceSku,
      Name: serviceProduct?.name || serviceProduct?.description || serviceSku,
      description: serviceProduct?.description || serviceProduct?.name || serviceSku,
      categories: serviceProduct?.categories || "Labor",
      category: "Labor",
      num_options: parentItem?.num_options || whichOption,
      quantity,
      Product_Quantity: quantity,
      pricePerItem: unitPrice,
      Product_Base_Price: unitPrice,
      totalPriceForItem: unitPrice,
      Product_Final_Price: unitPrice * quantity,
      extra_field_4: serviceProduct?.extra_field_4 || "0",
      autoAdded: true,
      autoLaborType: automationType,
      linkedParentUniqueID: parentItem?.uniqueID,
      linkedParentSku: parentItem?.Product_Name || parentItem?.id || "",
      uniqueID: "auto-" + automationType + "-" + (parentItem?.uniqueID || Date.now()),
    };
  };

  const syncAutoServiceLabor = (parentItem) => {
    if (!parentItem?.uniqueID) return;

    // Dealer quotes do not require automatic service labor.
    // If a linked labor item already exists for this parent, remove it.
    if (areYouDealer === "Dealer Selected") {
      dispatch(deleteLinkedLaborItems({ linkedParentUniqueID: parentItem.uniqueID }));
      return;
    }

    if (getAutoServiceFlag(parentItem) === "AUTO_SVC_SERVER") {
      dispatch(upsertLinkedLaborItem(buildLinkedServiceLaborItem("SVC-Server", parentItem, "AUTO_SVC_SERVER")));
    } else {
      dispatch(deleteLinkedLaborItems({ linkedParentUniqueID: parentItem.uniqueID }));
    }
  };

  // Box Data Show Starts Here

  let recorderData;
  if (productCSVQuery) {
    recorderData = productCSVQuery
      .filter((item) => {
        if (areYouDealer === "Dealer Selected") {
          if (item.hide_1 === "1") {
            return (
              item.categories &&
              item.categories.includes("DVRs & NVRs/NVR Recorders (IP Cameras)")
            );
          }
        } else {
          if (item.hide_1 === "0") {
            return (
              item.categories &&
              item.categories.includes("DVRs & NVRs/NVR Recorders (IP Cameras)")
            );
          }
        }
        return false;
      })
      .sort((a, b) => {
        return parseInt(a.sorting) - parseInt(b.sorting);
      });
  } else {
    console.error("productCSVQuery is undefined");
  }

  const handleButtonClick = (e, val, id, type) => {
    setEditing(type);

    let basePriceValue =
      type === "edit" ? val.Product_Base_Price : val.saleprice;
    if (!basePriceValue || isNaN(parseFloat(basePriceValue))) {
      basePriceValue = val.price || val.price_2 || "0";
    }
    const parsedBasePrice = parseFloat(basePriceValue) || 0;
    setBasePrice(parsedBasePrice);

    const initialQuantity = type === "edit" ? val.Product_Quantity : 1;
    setCount(initialQuantity);

    setShow(true); // Open Modal-1

    // Handle dropdown options
    let result = [];
    let currentArray = [];

    for (let i = 0; i < productOptionCSVQuery.length; i++) {
      const item = productOptionCSVQuery[i];
      if (
        item.productid === id ||
        (currentArray.length > 0 && item.productid === "")
      ) {
        currentArray.push(item);
      } else if (currentArray.length > 0) {
        result = currentArray;
        currentArray = [];
      }
    }

    if (currentArray.length > 0) {
      result = [...currentArray];
    }

    const result1 = [];
    let currentArray1 = [];

    for (let i = 0; i < result.length; i++) {
      const item = result[i];
      item.selected = false;

      if (val.option1_value === item.featurename) item.selected = true;
      if (val.option2_value === item.featurename) item.selected = true;
      if (val.option3_value === item.featurename) item.selected = true;
      if (val.option4_value === item.featurename) item.selected = true;
      if (val.option5_value === item.featurename) item.selected = true;
      if (val.option6_value === item.featurename) item.selected = true;

      if (item.productid === id) {
        if (currentArray1.length > 0) {
          result1.push([...currentArray1]);
          currentArray1 = [];
        }
        currentArray1.push(item);
      } else if (currentArray1.length > 0 || i === result.length - 1) {
        currentArray1.push(item);
      }
    }

    if (currentArray1.length > 0) {
      result1.push([...currentArray1]);
    }

    setDropDownData(result1);

    // Calculate dropdown prices
    const sumDefault = [];
    result1.forEach((item) => {
      const selectedOption = item.find((opt) => opt.selected);
      if (selectedOption) {
        sumDefault.push(Number(selectedOption.featureprice));
      }
    });

    const filteredSumDefault = sumDefault.filter((value) => value !== 0);
    const sum = filteredSumDefault.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    setAllDropDownPrice(sum);

    // Set unitPrice and priceList after dropdown prices are calculated
    const initialUnitPrice = parsedBasePrice + sum;
    setUnitPrice(initialUnitPrice);

    const initialTotalPrice = initialUnitPrice * initialQuantity;
    setPriceList(initialTotalPrice);

    // Final product state for modal
    let newState = {
      id: id || val.id || val.Product_Name,
      image1: val.image1 || val.thumbnail,
      image2: val.image2 || val.thumbnail,
      image3: val.image3 || val.thumbnail,
      thumbnail: val.thumbnail,
      description: val.description || val.Product_Description,
      price: parsedBasePrice,
      types: type,
      categories: val.categories || val.category,
      extra_field_5: val.extra_field_5,
      dropdownItems: val,
      unitPrice: initialUnitPrice,
    };

    if (val.extra_field_2 || val.drop) {
      newState = {
        ...newState,
        drop: val.extra_field_2 ? val.extra_field_2 : val.drop,
      };
    }

    setdataForProduct(newState);
    
  };

  const desiredOrder = [
    "CPU",
    "RAM",
    "M2 Drive (OS Drive)",
    "Number of IP Licenses",
    "Hard Drive Size",
    "Operating System",
  ];

  // Desired Order Ends

  // Final New State 2 Starts Here (Dropdown stored in state)
  useEffect(() => {
    const initialSelectedOptions = {};
    dropDownData.forEach((item) => {
      if (item.length > 0) {
        const firstOption = item[0];
        const selectedOption =
          item.find((option) => option.selected) || firstOption;
        initialSelectedOptions[firstOption.featurecaption] =
          selectedOption.featurename;
        initialSelectedOptions[firstOption.featurecaption + "_price"] =
          selectedOption.featureprice;
      }
    });

    // Override with pre-existing values for edit mode
    if (dataforProduct.types === "edit") {
      const val = dataforProduct.dropdownItems;
      if (val.option1_value) initialSelectedOptions["CPU"] = val.option1_value;
      if (val.option1_price)
        initialSelectedOptions["CPU_price"] = val.option1_price;
      if (val.option2_value) initialSelectedOptions["RAM"] = val.option2_value;
      if (val.option2_price)
        initialSelectedOptions["RAM_price"] = val.option2_price;
      if (val.option3_value)
        initialSelectedOptions["M2 Drive (OS Drive)"] = val.option3_value;
      if (val.option3_price)
        initialSelectedOptions["M2 Drive (OS Drive)_price"] = val.option3_price;
      if (val.option4_value)
        initialSelectedOptions["Number of IP Licenses"] = val.option4_value;
      if (val.option4_price)
        initialSelectedOptions["Number of IP Licenses_price"] =
          val.option4_price;
      if (val.option5_value)
        initialSelectedOptions["Hard Drive Size"] = val.option5_value;
      if (val.option5_price)
        initialSelectedOptions["Hard Drive Size_price"] = val.option5_price;
      if (val.option6_value)
        initialSelectedOptions["Operating System"] = val.option6_value;
      if (val.option6_price)
        initialSelectedOptions["Operating System_price"] = val.option6_price;
    }

    setFinalNewState2(initialSelectedOptions);
  }, [dropDownData, dataforProduct]);
  // Final News State 2 Ends Here

  // When you change the Input options on Modal
  // Handle Select Start Here
  function handleSelectChange(e) {
    const { name, value } = e.target;
    const selectedOption = dropDownData
      .flat()
      .find((option) => option.featurename === value);

    const removeDropdown = dropDownData.map((option) => {
      if (option[0].featurecaption === name) {
        option.forEach((item) => {
          item.selected = item.featurename === value;
        });
      }
      return option;
    });

    const sumDefault = [];
    removeDropdown.forEach((item) => {
      const selectedOption = item.find((opt) => opt.selected);
      if (selectedOption) {
        const featurePrice = parseFloat(selectedOption.featureprice) || 0;
        sumDefault.push(featurePrice);
      }
    });
    const filteredSumDefault = sumDefault.filter((value) => value !== 0);
    const newAllDropDownPrice = filteredSumDefault.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );

    setAllDropDownPrice(newAllDropDownPrice);

    setFinalNewState2((prevData) => ({
      ...prevData,
      [name]: value,
      [name + "_price"]: selectedOption
        ? parseFloat(selectedOption.featureprice) || 0
        : 0,
    }));

    const newUnitPrice = (parseFloat(basePrice) || 0) + newAllDropDownPrice;
    setUnitPrice(newUnitPrice);
    setPriceList(newUnitPrice * count);
    
  }
  // Handle Select Ends Here

  // Increase Count by +1
  const handlePlusClick = () => {
    setCount(count + 1);
  };
  // Decrease by - 1
  const handleMinusClick = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };
  // Increase by + 5

  const handlePlusClickByFive = () => {
    setCount(count + 5);
  };
  // Decrease by - 5
  const handleMinusClickByFive = () => {
    if (count > 5) {
      setCount(count - 5);
    }
  };

  // Increase Count by +10 :
  const handlePlusClickByTen = () => {
    setCount(count + 10);
  };
  // Decrease Count by -10
  const handleMinusClickByTen = () => {
    if (count > 10) {
      setCount(count - 10);
    }
  };

  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  // Reset the state ends
  // Reset form Ends here

  function handleInputChange(e) {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      setBasePrice(value === "" || value === "." ? 0 : parseFloat(value));
    }
  }

  const handleUnitCostFocus = () => {
    setUnitCostInput(String(basePrice ?? ""));
  };

  const handleUnitCostBlur = () => {
    setUnitCostInput("");
  };

  // Setting Unit Price
  useEffect(() => {
    const calculatedUnitPrice =
      (parseFloat(basePrice) || 0) + (allDropDownPrice || 0);
    setUnitPrice(calculatedUnitPrice);
    setPriceList(calculatedUnitPrice * (Number(count) || 0));
  }, [basePrice, allDropDownPrice, count]);

  useEffect(() => {
    let finalState = {
      num_options: whichOption,
      Product_Name: dataforProduct.id,
      Name: dataforProduct?.dropdownItems?.name,
      Product_Base_Price: parseFloat(basePrice) || 0,
      Product_Quantity: count,
      Product_Final_Price: parseFloat(unitPrice * count) || 0,
      image1: dataforProduct.image1,
      image2: dataforProduct.image2,
      image3: dataforProduct.image3,
      thumbnail: dataforProduct.thumbnail,
      categories: dataforProduct.categories,
      extra_field_5: dataforProduct.extra_field_5,
      unitPrice: parseFloat(unitPrice) || 0,
      description: dataforProduct.description,
    };

    if (dataforProduct.id === "ADDIPs" && dataforProduct.types === "edit") {
      finalState = {
        ...finalState,
        "Number of IP Licenses": `${count} IP Camera Licenses`,
        "Number of IP Licenses_price": 100,
      };
    }

    if (dataforProduct.drop) {
      finalState = {
        ...finalState,
        drop: dataforProduct.drop,
      };
    }

    setFinalNewState(finalState);
  }, [dataforProduct, unitPrice, count, basePrice]);

  function addNvrQuantity(type) {
    const mergedState = {
      ...finalNewState,
      ...finalNewState2,
      type,
      uniqueID:
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
      "Operating System": finalNewState2["Operating System"],
      "Operating System_price": finalNewState2["Operating System_price"],
    };

    if (finalNewState.Product_Name === "ADDIPs") {
      mergedState[
        "Number of IP Licenses"
      ] = `${finalNewState.Product_Quantity} IP Camera Licenses`;
      mergedState["Number of IP Licenses_price"] = 100;
    }

    dispatch(setSelectedNVR(mergedState));
    syncAutoServiceLabor(mergedState);
    setShow(false);
  }

  // function updateNVR(type, uniqueID = null) {
  //   const mergedState = {
  //     ...finalNewState,
  //     ...finalNewState2,
  //     type,
  //     uniqueID,
  //     "Operating System": finalNewState2["Operating System"],
  //     "Operating System_price": finalNewState2["Operating System_price"],
  //   };

  //   dispatch(updateNVRQuantity2(mergedState));
  //   setShow(false);
  // }

  function updateNVR(type, uniqueID = null) {
    const mergedState = {
      ...finalNewState,
      ...finalNewState2,
      type,
      uniqueID,
      "Operating System": finalNewState2["Operating System"],
      "Operating System_price": finalNewState2["Operating System_price"],
    };

    dispatch(updateNVRQuantity2(mergedState));
    syncAutoServiceLabor(mergedState);
    setShow(false);
  }

  function deleteFromTable(uniqueID) {
    dispatch(deleteNVR({ uniqueID }));
    dispatch(deleteLinkedLaborItems({ linkedParentUniqueID: uniqueID }));
  }

  // Calculate Total Licenses Starts Here
  // const calculateTotalLicenses = () => {
  //   let totalLicenses = 0;
  //   tableData.forEach((val) => {
  //     totalLicenses += parseInt(val.option4_value, 10) * val.Product_Quantity;
  //   });
  //   return totalLicenses;
  // };
  // Calculate Total Licneses Ends Here

  // Typed Increment Unit Cost Start
  const typedIncrement = () => {
    setUnitCostInput("");
    setBasePrice((prev) => (Number(prev) || 0) + 1);
  };

  const typedDecrement = () => {
    setUnitCostInput("");
    setBasePrice((prev) => Math.max(0, (Number(prev) || 0) - 1));
  };

  // Typed Increment Unit Cost Ends

  // Reset Form Start here

  const resetForm = () => {
    setCount(1);
    setAllDropDownPrice(0);
    setUnitPrice(0);
    setPriceList(0);
    setUpdatePrice(0);
    setFinalNewState2({});
  };
  // Reset the state start

  // Modal Title Changes Starts Here

  const {
    CPU: cpu_String,
    RAM: ram_String,
    "M2 Drive (OS Drive)": m2_String,
    "Number of IP Licenses": license_String,
    "Hard Drive Size": hardDrive_String,
  } = finalNewState2;

  // For CPU
  var string_for_cpu = cpu_String;
  var modifiedString_for_cpu = string_for_cpu
    ?.replace("Intel", "")
    ?.replace("CPU", "");

  // For RAM
  var string_for_ram = ram_String;
  var modifiedString_for_ram = string_for_ram
    ?.replace("DDR4", "")
    ?.replace("RAM", "")
    ?.replace("Installed", "");

  // For Licenses
  var string_for_license = license_String;
  var modifiedString_for_license = string_for_license
    ?.replace("IP", "")
    ?.replace("Camera", "")
    ?.replace("Licenses", "");

  // For Hard Drive
  var string_for_harDrive = hardDrive_String;
  var modifiedString_for_hardDrive = string_for_harDrive
    ?.replace("Hard", "")
    ?.replace("Drive", "")
    ?.replace("Installed", "");
  // Modal Title Ends Here

  //filter table data based on num_option selected
  const filterData = tableData.filter((item) => item.option === whichOption);

  //Calculate total camera selected
  const totalSelectedCameras = useSelector((state) => {
    const cameras = state.counter1.selectedCamera;
    const filteredCameras = cameras.filter(
      (item) => item.num_options === whichOption
    );
    let total = 0;
    filteredCameras.forEach((item) => {
      if (item.Product_Quantity) {
        total += item.Product_Quantity;
      }
    });
    return total;
  });

  useEffect(() => {
    //Calculate license in each option
    let license = 0;
    filterData.forEach((item) => {
      if (item.option4_value) {
        license += parseFloat(item.option4_value.replace(/\D/g, ""), 10);
      }
    });
    setTotalLicenses(license);

    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "nvr",
            quantity: license || 0,
            warning: totalCamerasRequired || 0,
            option: whichOption,
            navigationName: "/nvr",
          },
        })
      );
    }
  }, [filterData]);
  return (
    <>
      <Container fluid className="my-4">
        <Container className="navbar_margin">
          {/* NVR Header Info */}
          <Row>
            <Col
              className="marginTopSpace py-2"
              style={{ backgroundColor: "" }}
            >
              <h2>
                NVR Recorders
                <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>
            <Col
              className="marginTopSpace py-2"
              style={{ backgroundColor: "" }}
            >
              <Row>
                <Col className="text-end">
                  Number of Cameras Required:&nbsp;
                  <span className="fw-bold">{totalCamerasRequired}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total Cameras Selected:&nbsp;
                  <span className="fw-bold">{totalSelectedCameras}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Number of Licenses: &nbsp;
                  <span className="fw-bold">{totalLicenses}</span>
                  {/* <span className="fw-bold">{calculateTotalLicenses()}</span> */}
                </Col>
              </Row>
              {/* <Row>
              <Col className="text-end">
                Total number of drops:&nbsp;
                <span className="fw-bold">{filterData.length === 0 ? 0 : totalDrops}</span>
              </Col>
            </Row> */}
            </Col>
          </Row>

          {/* Arr to Cart Table */}
          <Row className="my-1" style={{ padding: "0px 8px" }}>
            <Col>
              <h5 className="fw-bold">Add to Cart: </h5>
              <div className="table-border">
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>QTY: </th>
                      <th>SKU: </th>
                      <th>Description & Options</th>
                      <th>Price: </th>
                      <th>Total: </th>
                      <th>Licenses: </th>
                      <th colSpan={2} className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((item, index) => {
                      return (
                        <tr
                          key={`${item.Product_Name}-${item.option}-${item.Product_Final_Price}`}
                        >
                          <td>{item.Product_Quantity}</td>
                          <td>{item.Product_Name}</td>
                          <td>
                            {item.Product_Description ? (
                              <>
                                <strong>{item.Product_Description}</strong>
                                <br />
                                {/* <strong>{item.Product_Name} - </strong>
                                {item.category
                                  ? item.category.replace("@Special/", "/")
                                  : "Unknown Category"}
                                <br /> */}
                              </>
                            ) : null}

                            {item && item.option1_value ? (
                              <>
                                <strong>{item.option1_name}:</strong>{" "}
                                {item.option1_value}{" "}
                                <strong>${item.option1_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option2_value ? (
                              <>
                                <strong>{item.option2_name}:</strong>{" "}
                                {item.option2_value}{" "}
                                <strong>${item.option2_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option3_value ? (
                              <>
                                <strong>{item.option3_name}: </strong>
                                {item.option3_value}{" "}
                                <strong>${item.option3_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option4_value ? (
                              <>
                                <strong>{item.option4_name}: </strong>
                                {item.option4_value}{" "}
                                <strong>${item.option4_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option5_value ? (
                              <>
                                <strong>{item.option5_name}: </strong>
                                {item.option5_value}{" "}
                                <strong>${item.option5_price}</strong>
                              </>
                            ) : null}
                          </td>
                          <td> ${Number(item?.unitPrice).toFixed(2)}</td>
                          <td>
                            {" "}
                            ${Number(item?.Product_Final_Price).toFixed(2)}
                          </td>

                          <td>
                            {item && item.option4_value ? (
                              <>{item.option4_value}</>
                            ) : null}
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "space-around",
                              }}
                            >
                              <Button
                                variant="dark"
                                onClick={(e) =>
                                  handleButtonClick(
                                    e,
                                    item,
                                    item.Product_Name,
                                    "edit"
                                  )
                                }
                              >
                                Edit
                              </Button>
                            </div>
                          </td>
                          <td>
                            <Button
                              variant="dark"
                              // onClick={() =>
                              //   deleteFromTable(item.Product_Name, item.option)
                              // }
                              onClick={() => deleteFromTable(item.uniqueID)}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center mb-3">
            {/* Show the warning to the before he moves to the next category */}
            {showWarningComponent ? (
              <WarningComponent
                path="/cameras"
                setShowWarningComponent={setShowWarningComponent}
              />
            ) : (
              ""
            )}
            <Button
              className=""
              variant="dark"
              onClick={() => setShowWarningComponent(true)}
            >
              Next
            </Button>
          </div>
          <Row className="mb-5">
            {recorderData.length > 0 &&
              recorderData.map((val, index) => {
                return (
                  <Col
                    key={val.id || index}
                    md={4}
                    onClick={(e) => {
                      handleButtonClick(e, val, val.id, "add");
                    }}
                    className="nvrContent mb-4"
                  >
                    <Card className="">
                      <Card.Body>
                        <Card.Title className="fw-bold">
                          SKU : {val.id}
                        </Card.Title>
                        <Card.Text>
                          Description :
                          {val.description != ""
                            ? val.description
                            : val.categories}
                        </Card.Text>
                        <Row
                          style={{
                            height: "185px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Col xs={8}>
                            <Card.Img
                              variant="top"
                              style={{
                                width: "100%",
                                height: "100%",
                                maxHeight: "200px",
                                objectFit: "contain",
                                // aspectRatio: "1",
                                border: "0px solid grey",
                              }}
                              src={"https://platinumcctv.com/" + val.thumbnail}
                            />
                          </Col>
                          <Col
                            xs={4}
                            className="d-flex align-items-center justify-content-center fw-bold"
                          >
                            $ {val.saleprice}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
          </Row>

          {/* Next Page Code */}
          {/* <Row className="my-4" style={{ backgroundColor: "" }}>
          <Col className="d-flex justify-content-end">
            <Button variant="dark" onClick={handleShow2}>
              Next
            </Button>
          </Col>
        </Row> */}
        </Container>
      </Container>

      {/* Modal-1 Code (Options, Price, DropDown) */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {`${dataforProduct.id || ""}`}

            {/* {`
  ${dataforProduct.id || ''}
  ${modifiedString_for_cpu ? '+' + modifiedString_for_cpu : ''}
  ${m2_String ? '+' + m2_String : ''}
  ${modifiedString_for_ram ? '+' + modifiedString_for_ram : ''}
  ${modifiedString_for_license ? '+' + modifiedString_for_license : ''}
  ${modifiedString_for_hardDrive ? '+' + modifiedString_for_hardDrive : ''}
`} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "" }}>
          <Row>
            {/* Left */}
            <Col md={4}>
              <Row>
                <Card.Img
                  variant="top"
                  height={150}
                  src={"https://platinumcctv.com/" + dataforProduct.thumbnail}
                />
              </Row>
              <Row className="my-2">
                <Col>
                  <Card.Img
                    variant="top"
                    height={50}
                    className="camera_thumbnail_img"
                    src={"https://platinumcctv.com/" + dataforProduct.thumbnail}
                  />
                </Col>
                <Col>
                  <Card.Img
                    variant="top"
                    height={50}
                    className="camera_thumbnail_img"
                    src={"https://platinumcctv.com/" + dataforProduct.thumbnail}
                  />
                </Col>
                <Col>
                  <Card.Img
                    variant="top"
                    height={50}
                    className="camera_thumbnail_img"
                    src={"https://platinumcctv.com/" + dataforProduct.thumbnail}
                  />
                </Col>
              </Row>
            </Col>

            {/* Right */}
            <Col md={8}>
              <p>
                Description:
                {dataforProduct.description != ""
                  ? dataforProduct.description
                  : dataforProduct.categories}
              </p>
              {desiredOrder.map((caption, index) => {
                const item = dropDownData.find(
                  (data) => data[0].featurecaption === caption
                );
                if (item) {
                  return (
                    <div key={index}>
                      <Form.Label>{item[0].featurecaption}</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        className="mb-3"
                        name={item[0].featurecaption}
                        value={finalNewState2[item[0].featurecaption] || ""}
                        onChange={(e) => handleSelectChange(e)}
                      >
                        {item.map((option, optionIndex) => {
                          return (
                            <option
                              name={option.featurecaption}
                              key={optionIndex}
                              value={option.featurename}
                            >
                              {option.featurename + " $" + option.featureprice}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </div>
                  );
                }
                return null;
              })}
              <div className="d-flex align-items-end justify-content-between my-4 ">
                Qty :
                <Button variant="dark" onClick={handleMinusClickByTen}>
                  -10
                </Button>
                <Button variant="dark" onClick={handleMinusClickByFive}>
                  -5
                </Button>
                <Button variant="dark" onClick={handleMinusClick}>
                  -
                </Button>
                <h6 className="mx-3">{count}</h6>
                <Button variant="dark" onClick={handlePlusClick}>
                  +
                </Button>
                <Button variant="dark" onClick={handlePlusClickByFive}>
                  +5
                </Button>
                <Button variant="dark" onClick={handlePlusClickByTen}>
                  +10
                </Button>
              </div>
              <div className="text-end mb-3">
                Option Cost: {(Number(allDropDownPrice) || 0).toFixed(2)}
              </div>
              {/* Unit Cost */}
              Unit Cost:
              <InputGroup className="mb-3">
                <Button
                  variant="dark"
                  className="mx-3"
                  onClick={typedDecrement}
                >
                  -
                </Button>
                <Form.Control
                  type="text"
                  value={unitCostInput !== "" ? unitCostInput : (Number(basePrice) || 0).toFixed(2)}
                  onFocus={handleUnitCostFocus}
                  onBlur={handleUnitCostBlur}
                  onChange={handleInputChange}
                />
                <Button
                  variant="dark"
                  className="mx-3"
                  onClick={typedIncrement}
                >
                  +
                </Button>
              </InputGroup>
              <h5>
                Final Price :
                {(unitPrice * count).toFixed(2).replace(/\.?0+$/, "")}
              </h5>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="w-100 my-4 d-flex align-items-end justify-content-between">
            <Button
              className="mx-3"
              variant="dark"
              onClick={() => setShow(false)}
            >
              Back
            </Button>

            {editing === "edit" && (
              <Button
                variant="dark"
                onClick={() =>
                  updateNVR("edit", dataforProduct?.dropdownItems?.uniqueID)
                }
              >
                Update NVR
              </Button>
            )}
            {editing === "add" && (
              <Button variant="dark" onClick={() => addNvrQuantity("add")}>
                Add
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Nvr;
